export const NOTIFICATIONS_QUERY_KEY = ["notifications"];

export const NOTIFICATION_PAGE_SIZE = 20;

export const NOTIFICATION_STALE_TIME = 30 * 1000;

export const NOTIFICATION_GC_TIME = 5 * 60 * 1000;

export const SCROLL_BOTTOM_THRESHOLD = 50;

export const MAX_BADGE_COUNT = 99;

export const NOTIFICATION_DATE_FORMAT = "dd MMM yyyy";

export const USE_LOCALIZED_MONTH_NAMES = true;

export const NOTIFICATION_DATE_MODE = {
  RELATIVE: "relative",
  ABSOLUTE: "absolute",
};

export const NOTIFICATION_BUCKET = {
  UNREAD: "unread",
  READ: "read",
};

export const NOTIFICATION_TARGET = {
  NONE: "none",
  TENDER_CHAT: "tender_chat",
  PROJECT: "project",
};

export const NOTIFICATION_KIND = {
  PDF_GENERATION_REQUIRED: "pdf_generation_required",
  PDF_READY: "pdf_ready",
  PDF_GENERATION_FAILED: "pdf_generation_failed",
  ACCESS_GRANTED: "project_access_granted",
  ACCESS_REVOKED: "project_access_revoked",
  TEXT: "text",
  IMAGE: "image",
  VIDEO: "video",
  DOCUMENT: "document",
};

export const PDF_NOTIFICATION_KINDS = [
  NOTIFICATION_KIND.PDF_GENERATION_REQUIRED,
  NOTIFICATION_KIND.PDF_READY,
  NOTIFICATION_KIND.PDF_GENERATION_FAILED,
];

export const ACCESS_NOTIFICATION_KINDS = [
  NOTIFICATION_KIND.ACCESS_GRANTED,
  NOTIFICATION_KIND.ACCESS_REVOKED,
];

export const TYPE_DRIVEN_NOTIFICATION_KINDS = [
  ...PDF_NOTIFICATION_KINDS,
  ...ACCESS_NOTIFICATION_KINDS,
];

export const NOTIFICATION_ICON = {
  AVATAR: "avatar",
  PDF: "pdf",
  ACCESS_GRANTED: "access_granted",
  ACCESS_REVOKED: "access_revoked",
};

export const NOTIFICATION_TITLE_SOURCE = {
  SENDER: "sender",
  LOCALIZED_MESSAGE: "localized_message",
  STATIC: "static",
  NONE: "none",
};

export const NOTIFICATION_SECTION = {
  NEW: "new",
  OLDER: "older",
};

export const NOTIFICATION_SECTION_LABEL_KEY = {
  [NOTIFICATION_SECTION.NEW]: "main.notifications.sections.new",
  [NOTIFICATION_SECTION.OLDER]: "main.notifications.sections.older",
};

export const NOTIFICATION_SECTION_FALLBACK_LABEL = {
  [NOTIFICATION_SECTION.NEW]: "New",
  [NOTIFICATION_SECTION.OLDER]: "Older",
};

export const NOTIFICATION_SECTION_SHOWS_COUNT = {
  [NOTIFICATION_SECTION.NEW]: true,
  [NOTIFICATION_SECTION.OLDER]: false,
};

export const NOTIFICATION_SECTION_DATE_MODE = {
  [NOTIFICATION_SECTION.NEW]: NOTIFICATION_DATE_MODE.RELATIVE,
  [NOTIFICATION_SECTION.OLDER]: NOTIFICATION_DATE_MODE.ABSOLUTE,
};
